// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetIndividualProjectByIdRequestModel from '../../model/get-individual-project-by-id-request-model';
import GetIndividualProjectByIdRequestDTO from '../dto/get-individual-project-by-id-request-dto';
import dtoSchema from '../schemas/get-individual-project-by-id-request-schema';

export default abstract class GetIndividualProjectByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetIndividualProjectByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetIndividualProjectByIdRequestDTO>): GetIndividualProjectByIdRequestModel;
  static toModel(dto: DeepPartial<GetIndividualProjectByIdRequestDTO> | undefined | null): GetIndividualProjectByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetIndividualProjectByIdRequestDTO> | undefined | null): GetIndividualProjectByIdRequestModel | undefined {
    return dto ? new GetIndividualProjectByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetIndividualProjectByIdRequestModel> | GetIndividualProjectByIdRequestModel): GetIndividualProjectByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetIndividualProjectByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetIndividualProjectByIdRequestModel, can not map to GetIndividualProjectByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
